import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const BusquedaDisponibilidad = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Informe/BusquedaDisponibilidad",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { BusquedaDisponibilidad };
